module.exports = __webpack_public_path__ + "assets/img/mockup_desktop.9dab32f6.svg";